import type { EventBusPayload } from "@/modules/event-bus";

import { useTranslation } from "react-i18next";

import { ONE_MINUTE_IN_SECONDS } from "@/constants/Time";
import { isJobModuleCompletedNotificationPayload } from "@/entities/broadcast-notification";
import { useUpdateJobModuleStateQueryData } from "@/entities/job-module";
import { useInvalidateNotifications } from "@/entities/notifications";
import { useAppNotification } from "@/modules/app-notification";
import { useAsyncActions } from "@/modules/async-actions";
import { OrganizationContextLabel } from "@/modules/organization/organization-context-label";

import { JobModuleActionLink } from "../job-module-action-link";

export const useJobModuleActionCompleted = () => {
  const { t } = useTranslation();
  const { notify } = useAppNotification();
  const { updateJobModuleState, invalidateJobModuleList } =
    useUpdateJobModuleStateQueryData();
  const { setUpdatedState } = useAsyncActions();
  const { invalidateNotifications } = useInvalidateNotifications();

  const runAction = (payload: EventBusPayload) => {
    if (!isJobModuleCompletedNotificationPayload(payload)) return;

    notify.success({
      key: payload.id,
      title: t("broadcast:jobModuleCompleted", {
        moduleName: payload.job_module.module_name,
      }),
      description: payload.job_module.subjects[0].name,
      descriptionRows: 2,
      actions: (
        <>
          <JobModuleActionLink
            customContext={payload.context}
            subject={payload.job_module.subjects[0]}
            onClick={() => notify.close(payload.id)}
          />
          <OrganizationContextLabel context={payload.context} isSmall />
        </>
      ),
      duration: ONE_MINUTE_IN_SECONDS,
    });

    setUpdatedState("jobmodule", payload.job_module.id);
    updateJobModuleState(payload.job_module.id, "Completed");
    invalidateJobModuleList();

    invalidateNotifications("*");
  };

  return { runAction };
};
